import { TrackJS } from "trackjs-nextjs"

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[]
}

declare const window: WindowWithDataLayer

export const pageview = (url: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "pageview",
      page: url,
    })
  } else {
    TrackJS.track(`[GTM-ERROR]: pageview tracking URL: ${url}`)
  }
}

export function gtag(data: any) {
  if (typeof window === "undefined") return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}

export function addEmailToDataLayer(email: string) {
  gtag({ email })
}
